import { ReactNode, useEffect, useState } from 'react';
import { Root } from './styles';
import { Fade } from '@mui/material';

export interface FloatingMessageProps {
  children: ReactNode;
  className?: string;
  /**@default true */
  visible?: boolean;
}

const FloatingMessage = ({ children, className, visible = true }: FloatingMessageProps) => {
  return (
    <Fade in={visible} appear={false} timeout={1000}>
      <Root className={className}>{children}</Root>
    </Fade>
  );
};

export default FloatingMessage;
